/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';

export class SupportedProviders {
  /**
  * Pre-configured cloud providers available for onboarding (from account configuration)
  */
  'onboarding': Array<Provider>;
  /**
  * Cloud providers the account has onboarded (has scanning accounts for)
  */
  'onboarded': Array<Provider>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "onboarding",
      "baseName": "onboarding",
      "type": "Array<Provider>",
      "format": ""
    },
    {
      "name": "onboarded",
      "baseName": "onboarded",
      "type": "Array<Provider>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SupportedProviders.attributeTypeMap;
  }

  public constructor() {
  }
}

